import { validateEID } from '@sso/traffic';
import { useEffect } from 'react';

const useValidateEID = ({ eid }: { eid?: string }) => {
  useEffect(() => {
    if (eid !== undefined) {
      validateEID({ eid });
    }
  }, [eid]);
};

export default useValidateEID;
